<template>
    <div class="scoller" style="min-width: 980px;">
        <slot>
            <b-list-group v-if="items && items.length > 0">
                <card-view v-for="(itm,idx) in items" :key="'itemsFiltered_' + idx" :item="itm" :index="idx" />
            </b-list-group>
        </slot>
    </div>
</template>
<script>
    import CardView from "@/components/Finance/CustomerPaymentCardView.vue"
    export default {
        props: {
            items: Array
        },
        components: {
            CardView
        }
    }
</script>